import {
    isFeatureEnabled,
    toFeatureState,
} from '@etrigan/feature-toggles-client'
import { TheWestSection } from '@news-mono/common'
import {
    LoadedElectionDefinition,
    StaticRoutes,
    UnloadedElectionDefinition,
} from '@news-mono/web-common'
import { ElectionDataResponse } from '@west-australian-newspapers/election-api-types'
import { createElectionWidgetTestPage } from './pages/electionWidgetTestPage'

const getElectionMeta = (wanElectionId: string) => {
    if (wanElectionId.startsWith('federal-')) {
        return {
            updatesSocialImage: require('./assets/federal-election-2025/UpdatesSocial.jpg'),
        }
    } else if (wanElectionId.startsWith('wa-')) {
        return {
            updatesSocialImage: require('./assets/wa-election-2025/UpdatesSocial.jpg'),
            electoratesSocialImage: require('./assets/wa-election-2025/ElectoratesSocial.jpg'),
            partyTotalsSocialImage: require('./assets/wa-election-2025/PartyTotalsSocial.jpg'),
        }
    } else {
        return {}
    }
}

const getElectionLogo = (wanElectionId: string, type: 'mobile' | 'desktop') => {
    // Split it on the '-' character
    const splitElectionId = wanElectionId.split('-')
    const [target, _, year] = splitElectionId
    let transformedFileName

    // If targeting federal Election, we know the file path
    if (target === 'federal') {
        transformedFileName = `federal-election-${year}/Logo${type
            .charAt(0)
            .toUpperCase()}${type.slice(1).toLowerCase()}.svg`
    } else {
        // Else, we need to add in key word State into file path
        transformedFileName = `${target.toLowerCase()}-election-${year}/Logo${type
            .charAt(0)
            .toUpperCase()}${type.slice(1).toLowerCase()}.svg`
    }

    return require(`./assets/${transformedFileName}`)
}

export const getLoadedElectionDefinition = (
    wanElectionId: string,
    electionData: ElectionDataResponse,
): LoadedElectionDefinition => {
    return {
        electionId: wanElectionId,
        electionData,
        loaded: true,
        logo: {
            desktop: getElectionLogo(wanElectionId, 'desktop'),
            mobile: getElectionLogo(wanElectionId, 'mobile'),
        },
        meta: getElectionMeta(wanElectionId),
    }
}
export const getUnloadedElectionDefinition = (
    wanElectionId: string,
): UnloadedElectionDefinition => {
    return {
        electionId: wanElectionId,
        loaded: false,
        logo: {
            desktop: getElectionLogo(wanElectionId, 'desktop'),
            mobile: getElectionLogo(wanElectionId, 'mobile'),
        },
        meta: getElectionMeta(wanElectionId),
    }
}

export const electionTestRoute: StaticRoutes<TheWestSection> = {
    ['/politics/election-widget-test-page']: ({ getAdTargeting, store }) => {
        const enableRoute = isFeatureEnabled(
            toFeatureState(store.getState().toggles),
            'election-widget-test-page',
        )

        if (!enableRoute) {
            return null
        }

        const testElectionId = 'wa-election-2025'
        const electionDefinition = getUnloadedElectionDefinition(testElectionId)

        return createElectionWidgetTestPage({
            // Default to the latest election.
            electionDefinition: electionDefinition,
            getAdTargeting,
        })
    },
}
